module.exports = __webpack_public_path__ + "static/media/1@720w.98e1cad9.jpg";